import { render, staticRenderFns } from "./ServiceSelection.vue?vue&type=template&id=effc6c1c&scoped=true&"
import script from "./ServiceSelection.vue?vue&type=script&lang=js&"
export * from "./ServiceSelection.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSelection.vue?vue&type=style&index=0&id=effc6c1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effc6c1c",
  null
  
)

export default component.exports